<template>
    <FullCalendar :options="calendarOptions" />
</template>

<script setup>
import { ref, onMounted } from 'vue'
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'

const props = defineProps({
    contractorId: Number,
    initialDate: String,  // 'YYYY-MM-DD'
})

const calendarOptions = ref({
    plugins: [dayGridPlugin, interactionPlugin],
    initialView: 'dayGridMonth',
    initialDate: props.initialDate,
    locale: 'pl',
    height: 'auto',
    events: async (fetchInfo, successCallback) => {
        const response = await axios.get(route('workplan-calendar-events'), {
            params: { contractor_id: props.contractorId }
        })
        successCallback(response.data)
    },
    eventColor: '#3b82f6',
    headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,dayGridWeek',
    },
})
</script>
